<template>
  <v-img :src="logo"
         contain
         :max-width=logoWidth
  ></v-img>
</template>

<script>
  export default {
    name: "NavLogo",
    computed: {
      logoWidth() {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return '287px';
        } else if (this.$vuetify.breakpoint.sm)
          return '241px';
        else {
          return '176px'
        }
      },
    },
    data() {
      return {
        logo: require('../../../src/assets/images/logo.svg')
      }
    }
  }
</script>

<style scoped>

</style>
